<div class="nav-top">
	<div class="nav-left-side">
		<span data-testid="SUBSYS2_NAVBAR_WELCOME_TXT" class="welcome-text" [title]="username()">
			{{ labels().NAVBAR_COMPONENT_WELCOME }} {{ username() }}
		</span>
	</div>
	<div class="nav-right-side position-static" ngbDropdown container="body" placement="bottom-right"
		(openChange)="getGuideList($event)">

		@if (isPlatformDemo()) {
		<span data-testid="SUBSYS2_NAVBAR_DEMO_TXT" class="demo-text">
			{{ labels().NAVBAR_COMPONENT_DEMO_MSG }}
		</span>
		}

		<language-selection />

		<span class="logo-text">{{labels().APP_LOGO_TEXT}}</span>

		@if (isMyhexplan()) {
		<a data-testid="SUBSYS2_NAVBAR_MYHEXPLAN_BTN" class="logo-text" [href]="myhexplanUrl" target="_blank">
			{{labels().NAVBAR_COMPONENT_LINK_MYHEXPLAN}}
		</a>
		}

		<a data-testid="SUBSYS2_NAVBAR_EMAIL_BTN" class="nav-top-link" href="mailto:{{customerCareEmail}}"
			[title]="labels().NAVBAR_COMPONENT_CONTACT_US"><i class="material-icons">mail_outline</i>
		</a>

		<a data-testid="SUBSYS2_NAVBAR_GUIDE_BTN" class="nav-top-link" ngbDropdownToggle
			[title]="labels().NAVBAR_COMPONENT_GUIDE">
			<img class="ifu-icon" alt="ifu icon">
		</a>

		<div data-testid="SUBSYS2_NAVBAR_HELP_BTN" class="nav-top-link" (click)="openHelpModal()"
			(keypress)="openHelpModal()" [title]="labels().NAVBAR_COMPONENT_HELP">
			<i class="material-icons-outlined">live_help</i>
		</div>

		<div class="dropdown-menu no-line" ngbDropdownMenu style="max-width: 30rem;">
			<a data-testid="SUBSYS2_NAVBAR_IFUSITE_BTN" [href]="eifuSiteUrl" target="_blank"
				class="dropdown-item text-truncate" [title]="labels().NAVBAR_COMPONENT_LINK_EIFU">
				{{ labels().NAVBAR_COMPONENT_LINK_EIFU }}
			</a>
			@for (guide of guideList; track $index) {
			@let guideLabel = labels()[guide.labelKey];
			<div data-testid="SUBSYS2_NAVBAR_GUIDEITEM_BTN" class="dropdown-item text-truncate" [title]="guideLabel"
				(click)="openGuide(guide.path)" (keypress)="openGuide(guide.path)">{{ guideLabel }}</div>
			}
		</div>

	</div>
</div>